import api from '../api/api';
import axios from 'axios';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {gameList, games} from '../api/apiHelper';

export const fetchGameList = createAsyncThunk('game/fetchGameList', async (arg, {signal}) => {
  const source = axios.CancelToken.source();
  signal.addEventListener('abort', () => {
    source.cancel();
  });
  const response = await api(gameList(arg, {cancelToken: source.token}));

  return response.data;
});

export const fetchGames = createAsyncThunk('game/fetchGames', async (arg, {signal}) => {
  const source = axios.CancelToken.source();
  signal.addEventListener('abort', () => {
    source.cancel();
  });
  const response = await api(games(arg, {cancelToken: source.token}));

  return response.data;
});

const extraReducers = {
  [fetchGameList.pending]: (state, action) => {
    const {gameType} = action.meta.arg;
    state.slot[gameType] = {...action.payload, loading: true};
  },
  [fetchGameList.fulfilled]: (state, action) => {
    const {gameType} = action.payload;
    state.slot[gameType] = {...action.payload, loading: false};
  },
  [fetchGames.pending]: (state, action) => {
    const {gameCate} = action.meta.arg;
    state[gameCate] = {...action.payload, loading: true};
  },
  [fetchGames.fulfilled]: (state, action) => {
    const {gameCate} = action.meta.arg;
    state[gameCate] = {...action.payload, loading: false};
  },
};

const initialState = {
  gameCategory: 'sport',
  slot: {
    JK: {},
    AC: {},
    SG: {},
    XE: {},
  },
  casino: [],
  sport: [],
  fishing: [],
  card: [],
  lotto: [],
  hot: [],
};

export const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setGameCategory: (state, action) => {
      state.gameCategory = action.payload;
    },
    reset: () => initialState,
  },
  extraReducers,
});

// Action creators are generated for each case reducer function
export const {reset, setGameCategory} = gameSlice.actions;

export default gameSlice.reducer;
